import React from 'react'

const WithLayout = (Layout, Page) => (props) =>
(
    <Layout>
        <Page {...props} />
    </Layout>
)

export default WithLayout
